import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/";

// import CircleLoader from './shared/CircleLoader';
// import SmallLoader from './shared/SmallLoader';
import Inline from './shared/Inline';
import Block from './shared/Block';
// import Center from './shared/Center';
// import Separator from './shared/Separator';
// import Float from './shared/Float';
import VMargin from './shared/VMargin';
import HMargin from './shared/HMargin';
import Label from './shared/Label';
// import TextWithBorder from './shared/TextWithBorder';
// import GreyLabel from './shared/GreyLabel';
import VPadding from './shared/VPadding';
// import HPadding from './shared/HPadding';
// import Explorer from './shared/Explorer';
// import HSeparator from './shared/HSeparator';
import Title from './shared/Title';
import Subtitle from './shared/Subtitle';
// import SharedTag from './shared/Tag';
import MediaTypeOrder from './components/TextMessage/MediaTypeOrder';
import OrderItem from './components/Widgets/Orders/OrderItem';
import RPBasicCardVue from './shared/RPBasicCard';
import reorderButton from './components/Widgets/Orders/reorderButton.vue'
import ScenarioBreadCrumb from './components/Widgets/ScenarioBreadCrumb';
import ScenarioBackButton from './shared/ScenarioBackButton';
import DotLoader from './shared/DotLoader.vue'


import VueTimeago from 'vue-timeago'
import { distanceInShortWords, removeTimeAgoHelpers } from './helper/timeAgoHelpers'


import {
	Icon,
	Popover,
	Input,
	Button,
	Rate,
  Tooltip,
	CheckboxButton,
	Radio,
	RadioGroup,
	RadioButton,
  Checkbox,
	CheckboxGroup,
	InputNumber,
  Loading,
  DatePicker,
  Select,
  Option,
  OptionGroup,
  Switch,
  Upload,
  Avatar,
  Progress,
  Col,
  Row
} from 'element-ui';
import './element-variables.scss';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import Emojis from './emojis';
import { getCookieByName } from './utils';
import linkify from 'vue-linkify'
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';

Vue.directive('linkified', linkify) 

locale.use(lang);
Vue.use(Col);
Vue.use(Row);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Button);
Vue.use(Loading.directive);
Vue.component(Icon.name, Icon)
Vue.component(Popover.name, Popover);
Vue.component(Rate.name, Rate);
Vue.component(Tooltip.name, Tooltip);
Vue.component(Checkbox.name, Checkbox);
Vue.component(CheckboxGroup.name,CheckboxGroup);
Vue.component(CheckboxButton.name, CheckboxButton);
Vue.component(Radio.name, Radio);
Vue.component(RadioButton.name, RadioButton);
Vue.component(RadioGroup.name, RadioGroup);
Vue.component(DatePicker.name, DatePicker);
Vue.component(Select.name, Select);
Vue.component(Option.name, Option);
Vue.component(OptionGroup.name, OptionGroup);
Vue.component(Switch.name, Switch);
Vue.component(Upload.name, Upload);
Vue.component(Avatar.name, Avatar);
Vue.component(Progress.name, Progress)
Vue.component(CollapseTransition.name, CollapseTransition)
// Vue.component('SmallLoader', SmallLoader);
Vue.component('Label', Label);
Vue.component('Block', Block);
Vue.component('Inline', Inline);
// Vue.component('Center', Center);
// Vue.component('Separator', Separator);
Vue.component('VMargin', VMargin);
Vue.component('HMargin', HMargin);
// Vue.component('Float', Float);
// Vue.component('TextWithBorder', TextWithBorder);
// Vue.component('CircleLoader', CircleLoader);
// Vue.component('GreyLabel', GreyLabel);
Vue.component('VPadding', VPadding);
// Vue.component('HPadding', HPadding);
// Vue.component('Explorer', Explorer);
// Vue.component('HSeparator', HSeparator);
Vue.component('Title', Title);
// Vue.component('Tag', SharedTag);
Vue.component('Subtitle', Subtitle);
Vue.component('MediaTypeOrder', MediaTypeOrder)
Vue.component('OrderItem', OrderItem)
Vue.component('RPBasicCardVue', RPBasicCardVue)
Vue.component('RPSecondaryCTA', reorderButton)
Vue.component('RPBreadCrumb', ScenarioBreadCrumb)
Vue.component('rp-dot-loader', DotLoader)
Vue.component('ScenarioBackButton', ScenarioBackButton)

import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
	load: {
		key: "AIzaSyDxSDblYYJn7_aOu4R7g5Ww4TeXw73Nnjs",
		libraries: "places" 
	},
	installComponents: true,
});

Vue.config.productionTip = false;


const messengerConf = {
	"helpdeskConfig": {
		"type": "RICHPANEL",
	},
	"helpcenterMode": 'fullscreen',
	'helpcenterStyles': {
		"color":"#ff1a62",
		"brandLogo":"brandImages/aad0f194-6634-4562-8835-60294acf8c08/637966 (3).jpg",
		"brandIcon":"NA",
		"socialMediaLink": {
			"twitter":"www.twitter.com/",
			"website":"http://facebook.com",
			"facebook":"https://google"
		}
	},
	"helpcenterStatus": true,
	"tenantId": "richpaneldev415",
	"accentColor": "#96093d",
	"contactDetails": {
	  "isActive": true,
	  "askFor": "email"
	},
	"email": {
	  "alsoAskForQualification": false,
	  "requirement": "never"
	},
	"messengerStatus": true,
	"availability": {
	  "replyTime": "The team typically replies in a few hours.",
	  "startTime": "09:00",
	  "endTime": "17:00",
	  "selectedDay": "WEEKENDS"
	},
	"faqLabel": "Get help",
	"replyTime": true,
	"id": "richpaneldev41536",
	"routing": {
	  "isActive": true,
	  "routingType": "assignment",
	  "routingTo": "unassigned"
	},
	"welcome": {
	  "greeting": "Hi <no-data data-name=\"firstName\" data-fallback=\"There\"></no-data>,",
	  "intro": "We are ramaiah-dev3.myshopify.com, feel free to ask us any questions.",
	  "defaultLanguage": "en"
	},
	"control": {
	  "messengerIconPosition": "right",
	  "bottomSpacing": 20,
	  "visibilityCode": "SHOW-CONTAINS",
	  "showMessengerToAllUsers": true,
	  "sideSpacing": 20,
	  "showMessengerToAllLeads": true,
	  "canCreateNewConversations": true,
	  "advancedMessengerVisibility": false
	},
	"rating": true,
	"orderStatus": true,
	"customLauncherSettings": {
	  "messengerSelectors": [
		"#rp-home"
	  ],
	  "prechatSurveySelectors": [
		"#rp-prechat"
	  ],
	  "helpCenterSelectors": [
		"#rp-helpcenter"
	  ],
	  "sendMessageSelectors": [
		{
		  "selectors": [
			"#rp-message"
		  ],
		  "intialMessage": "Hi There"
		}
	  ]
	},
	"createdAt": "2020-01-29T08:35:36.891Z",
	"brand": "Richpanel Dev",
	"preChatForm": {
	  "formTitle": "Talk to us",
	  "properties": [
		{
		  "propertyName": "firstName"
		}
	  ],
	  "isEnabled": false
	},
	"style": {
	  "backgroundColor": "#96093d",
	  "activeColor": "#96093d",
	  "toPlaySound": true,
	  "teamToRespond": "all"
	},
	"activeOption": 0,
	"backgroundImage": "null",
	"qualification": {
	  "isActive": true,
	  "properties": [
		{
		  "propertyName": "firstName"
		}
	  ]
	},
	"faqStatus": true,
	"updatedAt": "2020-01-29T08:35:36.891Z",
	"welcomeText": "What can we do for you today?",
	"brandId": "richpaneldev415b0",
	"title": "Welcome to ramaiah-dev3.myshopify.com.",
	"brandData": {
	  "updatedAt": "2020-01-29T08:28:55.118Z",
	  "tenantId": "richpaneldev415",
	  "brandId": "richpaneldev415b0",
	  "brandName": "Richpanel Dev",
	  "isDefault": true,
	  "createdAt": "2020-01-29T08:28:55.118Z",
	  "timezone": "New_York -04:00",
	  "customDomainName": "NA",
	  "domainName": "richpaneldev.dev.customerdesk.io",
	  "appClientId": "richpaneldev4150",
	  "language": "en"
	},
	"currency": {
	  "name": "Indian rupee",
	  "country": "India",
	  "symbol": "₹",
	  "code": "INR",
	  "label": "Indian rupee (₹)"
	}
}

const richPanelLocalizationData = {
	"id":"kplltd447",
	"appClientId":"kplltd4470",
	"timezone": "Central -05:00"
}
window.richpanelSettings = window.richpanelSettings || {};
window.richpanelSettings['cookieId'] = parent.Richpanel.cookieId || getCookieByName('rpdid') || 'ddd6fff35c14p7-e115-4d18-8122-5afdc9212eb4';
window.richpanelSettings['sid'] = parent.Richpanel.sid || getCookieByName('rpsid') || 'ddddsome-random-session-ifd';
window.richpanelSettings['appClientId'] = parent.Richpanel.appClientId || getCookieByName('rptkn') || 'richpaneldev41536';
if (parent !== window) {
	window.richpanelSettings['user_properties'] = parent.richpanelSettings;
}
const getDefaultLang = () => {
	try {
		if(parent.messengerConf && parent.messengerConf.brandData) return parent.messengerConf.brandData.language || 'en';
		else {
			return parent.messengerConf.welcome.defaultLanguage || 'en'
		}
	} catch (e) {
		return 'en';
	}
} 
const getLocalizationDataFromMessengerConf = (conf) => {
	if(conf && conf.brandData) {
		return {
			timezone: conf.brandData.timezone,
			id: conf.brandData.tenantId,
		}
	}
}
function getDateTimeLocale (langCode) {
	try {
		return {
			[langCode]: require(`date-fns/locale/${langCode}`)
		}
	} catch(e){
		console.error(e, "locale not found for date time")
		return {}
	}
}
Vue.use(VueTimeago, {
	name: 'Timeago', // Component name, `Timeago` by default
	locale: getDefaultLang(), // Default locale
	converter: (date, locale, converterOptions) => {
	  const { includeSeconds = true, addSuffix, shortWordDistance = true } = converterOptions;
	  let timeAgo = require('date-fns/distance_in_words_to_now')(date, {
		  locale,
		  includeSeconds,
		  addSuffix
	  });
	  if(['es', 'en'].includes(getDefaultLang())) {
		timeAgo = removeTimeAgoHelpers(timeAgo);
	  	return shortWordDistance ?  distanceInShortWords(timeAgo) : timeAgo;
	  }
	  return timeAgo;
	},
	converterOptions: {
	  includeSeconds: true,
	  addSuffix: false,
	},
	// We use `date-fns` under the hood
	// So you can use all locales from it
	locales: getDateTimeLocale (getDefaultLang())
})
import { initI18n } from './i18n/init'


const app = new Vue({

	router,

	store,

	i18n: initI18n(getDefaultLang()),

	render: h => h(App),

	data: {
		richpanelSettings: window.richpanelSettings,
		configuration: parent.messengerConf || messengerConf,
		localization: getLocalizationDataFromMessengerConf(parent.messengerConf) || richPanelLocalizationData,
		hostData: parent.location,
		imagesCache: {},
		defaultLanguage: getDefaultLang()
	}

}).$mount("#rp_messenger");

app.emojis = Emojis;
